import axios from 'axios'
import conf from './config'

import queryString from 'query-string'

export function makeSpotifyRequest(url, accessToken){
    return axios.get(`${url}`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
            }
        }
    )
}
export function makeSpotifyPostRequest(url, data, accessToken){
    const options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        }
    }
    return axios.post(`${url}`,  data, options)
}
export function makeSpotifyPutRequest(url, data, accessToken){
    const options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        }
    }
    return axios.put(`${url}`,  data, options)
}
export function makeSpotifyDeleteRequest(url, data, accessToken){
    const options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        }
    }
    return axios.delete(`${url}`,  data, options)
}
export function makeSpotifyAuthRequest(data){
    const options = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Basic ${btoa(`${conf.SPOTIFY_CLIENT_ID}:${conf.SPOTIFY_CLIENT_SECRET}`)}`
        },
        json: true
    }

    return axios.post(`https://accounts.spotify.com/api/token`, queryString.stringify(data), options)
}